import React, { Component, ReactNode } from 'react';
import { UnhandledException } from '../UnhandledException';

interface Props {
  children?: ReactNode;
}

interface State {
  error?: Error;
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      error: undefined,
      hasError: false,
    };
  }

  static getDerivedStateFromError(errorCaught: Error): Partial<State> | null {
    console.log(errorCaught);
    // Update state so the next render will show the fallback UI.
    return { error: errorCaught, hasError: true };
  }

  resetError = (): void => {
    if (this.state.error && this.state.hasError) {
      this.setState({ error: undefined, hasError: false });
    }
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return <UnhandledException resetErrorState={this.resetError} error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
